/**
 * @ Author: Your name
 * @ Create Time: 2019-06-13 14:21:24
 * @ Modified by: Your name
 * @ Modified time: 2019-06-25 11:06:50
 * @ Description: 对参数进行去空处理
 */
// eslint-disable-next-line import/prefer-default-export
export function trim(param, obj) {
  // console.log('param', param)
  const keys = Object.keys(param)
  keys.forEach(item => {
    if (typeof param[item] === 'string') {
      obj[item] = param[item].trim()
    }
    if (typeof param[item] === 'number') {
      // eslint-disable-next-line radix
      obj[item] = parseInt(`${param[item]} `.trim())
    }
    if (param[item] instanceof Object) {
      const objKey = Object.keys(param[item])
      objKey.forEach(items => { // 角色管理
        obj[item][items] = typeof param[item][items] === 'string' ? param[item][items].trim() : param[item][items]
      })
    }
  })
}
